import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedAdminRoute({ children }) {
  const { user, initializing } = useAuth();

  if (initializing || user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-[#1e1e2d]"
        data-testid="admin-loading"
      >
        <Loader2 className="w-8 h-8 text-[#FF9933] animate-spin" />
      </div>
    );
  }

  if (user === false || !user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
